
import store from '@/store';
import { internalFieldNames, Edge } from '@/types';
import DragTarget from '@/components/DragTarget.vue';
import { computed, defineComponent, ref } from '@vue/composition-api';
import EdgeBuilderChart from '@/components/EdgeBuilderChart.vue';
import LegendChart from '@/components/LegendChart.vue';

export default defineComponent({
  components: {
    DragTarget,
    EdgeBuilderChart,
    LegendChart,
  },

  setup() {
    const showOptions = ref(false);
    const network = computed(() => store.state.network);
    const nestedVariables = computed(() => store.state.nestedVariables);
    const edgeVariables = computed(() => store.state.edgeVariables);

    const columnTypes = computed(() => store.state.columnTypes);

    function cleanVariableList(list: Set<string>): Set<string> {
      const cleanedVariables = new Set<string>();

      list.forEach((variable) => {
        if (columnTypes.value !== null && columnTypes.value[variable] !== 'label') {
          cleanedVariables.add(variable);
        }
      });

      return cleanedVariables;
    }

    const cleanedEdgeVariables = computed(() => {
      if (network.value !== null) {
        // Loop through all edges, flatten the 2d array, and turn it into a set
        const allVars: Set<string> = new Set();
        network.value.edges.map((edge: Edge) => Object.keys(edge).forEach((key) => allVars.add(key)));

        internalFieldNames.forEach((field) => allVars.delete(field));
        allVars.delete('source');
        allVars.delete('target');
        allVars.delete('index');

        return cleanVariableList(allVars);
      }
      return new Set();
    });

    const displayCharts = computed(() => store.state.displayCharts);

    return {
      showOptions,
      edgeVariables,
      cleanedEdgeVariables,
      displayCharts,
      nestedVariables,
    };
  },
});
